import { render, staticRenderFns } from "./TheCalendar.vue?vue&type=template&id=c8f5c47a&scoped=true&"
import script from "./TheCalendar.vue?vue&type=script&lang=js&"
export * from "./TheCalendar.vue?vue&type=script&lang=js&"
import style0 from "./TheCalendar.vue?vue&type=style&index=0&id=c8f5c47a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f5c47a",
  null
  
)

export default component.exports